import { Component, Inject, Input, OnInit, PLATFORM_ID, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/API/api.service';
import { LocalstorageService } from 'src/app/services/localstorage/localstorage.service';
import { WindowRef } from 'src/app/services/windowRef/window-ref.service';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ContactService } from 'src/app/services/contact/contact.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { InfoModalComponent } from 'src/app/shared/modules/info-modal/info-modal/info-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MiniMetricsService } from 'src/app/services/minimetrics/minimetrics.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
	selector: 'app-lesson-bottom',
	templateUrl: './lesson-bottom.component.html',
	styleUrls: ['./lesson-bottom.component.scss']
})
export class LessonBottomComponent implements OnInit {
	public techCards = [
		{
			buttonTitle: 'Launch to get started',
			location: 'public',
			authenticationRequired: false,
			card: [
				{
					content: 'open this lesson?'
				},
				{
					content: 'preview this lesson?'
				},
				{
					content: 'use this lesson with your learners?'
				}
			]
		},
		{
			buttonTitle: 'Enroll to get started',
			authenticationRequired: true,
			location: 'auth',
			card: [
				{
					content: 'enroll your learners in the lesson?'
				},
				{
					content: 'collect data on your learners?'
				},
				{
					content: 'monitor your learners’ progress?'
				},
				{
					content: 'integrate the lesson into your pre-existing online course?'
				}
			]
		},
		{
			buttonTitle: 'Customize to get started',
			authenticationRequired: true,
			location: 'request',
			card: [
				{
					content: 'customize the lesson for your learners?'
				},
				{
					content: 'enroll your learners in the customized version?'
				},
				{
					content:
						'share your customized version with the infiniscope Teaching Network?'
				}
			]
		}
	];

	@ViewChild('modalLaunch', { static: true }) modalLaunch!: ElementRef;
	@ViewChild('modalDupe',   { static: true }) modalDupe!: ElementRef;
	@ViewChild('modalTorus',   { static: true }) modalTorus!: ElementRef;

	public domain: string;
	public toggleModelDuplicate: boolean = false;
	public toggleModelTorus: boolean = false;
	public toggleModalLaunch: boolean = false;
	get authenticated(): boolean {
		return this.api.authenticated;
	}
	public communityId: number = environment.community_id;

	@Input() requireAuthentication: boolean;
	@Input() lesson: any;
	@Input() contentType: string;

	constructor(
		private api: ApiService,
		public localStorage: LocalstorageService,
		@Inject(PLATFORM_ID) private platformId: any,
		private window: WindowRef,
		private deviceService: DeviceDetectorService,
		public router: Router,
		private dialog: MatDialog,
		private contactServcice: ContactService,
		private auth: AuthenticationService,
		private miniMetricService: MiniMetricsService
	) {}

	ngOnInit(): void {
		this.domain = window.location.origin;
	}

	public goToPage(url: string) {
		if (!url) return;
		if (isPlatformBrowser(this.platformId)) {
			this.window.nativeWindow.open(url, '_blank');
			this.clearAllModals();
		}
	}

	clearAllModals(): void {
		this.toggleModalLaunch = false;
		this.toggleModelDuplicate = false;
		this.toggleModelTorus = false;
	}

	modalKeydown(event: KeyboardEvent, keyStr): void {
		let modalItem;
		switch(keyStr) {
		case 'launch': modalItem = this.modalLaunch; break;
		case 'dupe': modalItem = this.modalDupe; break;
		case 'torus': modalItem = this.modalTorus; break;
		default: console.error('Uncaught modal type'); return;
		}

		if (event.key === 'Escape') {
			this.clearAllModals();
		}
	
		if (event.key === 'Tab') {
			const focusableElements = modalItem.nativeElement.querySelectorAll(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			);
			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];
			if (event.shiftKey && document.activeElement === firstElement) {
				event.preventDefault();
				lastElement.focus();
			} else if (!event.shiftKey && document.activeElement === lastElement) {
				event.preventDefault();
				firstElement.focus();
			}
		}
	}

	public modalToggleCardLaunch() {
		this.toggleModalLaunch = !this.toggleModalLaunch;
		// console.log('modalToggleCardLaunch', this.toggleModalLaunch);
	}

	public handlePublicClick() {
		this.miniMetricService.increaseWatch(this.contentType, this.lesson.id);
		this.goToPage(this.lesson.publicUrl);
	}

	public handleClick(location: string) {
		if (location == 'public') {
			if (!this.deviceService.isMobile() && this.window.nativeWindow.innerWidth >= 768) { this.handlePublicClick(); }
			else { this.modalToggleCardLaunch(); }
		} else if (location === 'request') {
			this.toggleModelTorus = false;
			if (this.lesson.customizeUrl) {
				if (!this.lesson.customizeUrl.includes('argos.education')) {
					this.goToPage(this.lesson.customizeUrl);
				} else {
					this.goToPage(
						`${this.lesson.customizeUrl}?id_token=${this.localStorage.getItem(
							'cognito_id_token'
						)}&community_id=${this.communityId}&error_url=${
							environment.infiniscope_url + this.router.url
						}`
					);
				}
			} else {
				this.toggleModelDuplicate = true;
			}
			document.getElementById('exampleModalLongTitle').focus();
		} else if (location === 'auth') {
			if (isPlatformBrowser(this.platformId)) {
				this.toggleModelTorus = true;
				this.toggleModelDuplicate = false;
			}
			document.getElementById('exampleModalLongTitle').focus();
		}
	}

	public requestDuplication() {
		const user = this.auth.currentUserValue;
		if (user) {
			this.miniMetricService.increaseShare(this.contentType, this.lesson.id);
			this.contactServcice
				.sendContentCopyRequest(
					this.lesson?.id + ' - ' + this.lesson?.title,
					this.lesson?.objectType,
					user.id
				)
				.then((res) => {
					this.clearAllModals();
					this.dialog.open(InfoModalComponent, {
						width: '600px',
						panelClass: 'addTagModal',
						data: {
							title: 'Success',
							msg:
								'Your request was sent by email successfully, please wait for a response by email on the email address you use with Infiniscope.'
						}
					});
				})
				.catch((err) => {
					this.clearAllModals();
					console.log(err);
					this.dialog.open(InfoModalComponent, {
						width: '600px',
						panelClass: 'addTagModal',
						data: {
							title: 'Sorry! An error occured.',
							msg: err.error.message
						}
					});
				});
		}
	}
}
